(() => {
  const overlay = document.getElementById("oi-nlp-overlay");
  if (!overlay)
    return;

  const closeBtn = overlay.querySelector(".oi-nlp-close");
  const form = document.getElementById("oi-nlp-form");
  const emailEl = document.getElementById("oi-nlp-email");
  const hpEl = document.getElementById("oi-nlp-hp");
  const errEl = document.getElementById("oi-nlp-error");
  const successEl = document.getElementById("oi-nlp-success");

  const triggerPct = Number(overlay.dataset.scrollTrigger || 30) / 100;
  const frequency = (overlay.dataset.frequency || "day").toLowerCase();
  const companyId = (overlay.dataset.companyId || "").trim();
  const listId = (overlay.dataset.listId || "").trim();
  const source = (overlay.dataset.source || "Newsletter Popup").trim();
  const rotationSpeed = Number(overlay.dataset.rotationSpeed || 3000);
  
  const setPopupHeight = () => {
    document.documentElement.style.setProperty('--popup-height', `${window.innerHeight}px`);
  };
  window.addEventListener('resize', setPopupHeight);
  setPopupHeight();

  const slides = Array.from(overlay.querySelectorAll(".oi-nlp-image__slide"));
  let rotationInterval = null;
  let currentSlideIndex = 0;

  function startRotation() {
    if (slides.length <= 1)
      return;

    if (rotationInterval)
      clearInterval(rotationInterval);

    rotationInterval = setInterval(() => {
      slides[currentSlideIndex].classList.remove("is-active");
      currentSlideIndex = (currentSlideIndex + 1) % slides.length;
      slides[currentSlideIndex].classList.add("is-active");
    }, rotationSpeed);
  }

  function stopRotation() {
    if (rotationInterval) {
      clearInterval(rotationInterval);
      rotationInterval = null;
    }
  }

  const KEY_PREFIX = "oi_nlp_v1";
  const DISMISS_UNTIL_KEY = `${KEY_PREFIX}_dismiss_until`;
  const SUBMITTED_KEY = `${KEY_PREFIX}_submitted`;
  const SUBMIT_TS_KEY = `${KEY_PREFIX}_submit_ts`;

  function now() {
    return Date.now();
  }

  function lockScroll(lock) {
    if (lock) {
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const y = window.scrollY || window.pageYOffset || 0;
      document.body.dataset.oiNlpScrollY = String(y);

      if (isMobile) {
        document.documentElement.classList.add("oi-nlp-lock");
        document.body.classList.add("oi-nlp-lock");
        document.body.style.position = "fixed";
        document.body.style.top = `-${y}px`;
        document.body.style.left = "0";
        document.body.style.right = "0";
        document.body.style.width = "100%";
      }
    } else {
      const y = parseInt(document.body.dataset.oiNlpScrollY || "0", 10) || 0;

      document.documentElement.classList.remove("oi-nlp-lock");
      document.body.classList.remove("oi-nlp-lock");

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";

      delete document.body.dataset.oiNlpScrollY;
      window.scrollTo(0, y);
    }
  }

  function setDismissUntil(ts) {
    localStorage.setItem(DISMISS_UNTIL_KEY, String(ts));
  }

  function getDismissUntil() {
    return Number(localStorage.getItem(DISMISS_UNTIL_KEY) || 0);
  }

  function shouldShow() {
    if (window.Shopify && window.Shopify.designMode)
      return true;

    if (localStorage.getItem(SUBMITTED_KEY))
      return false;

    return now() > getDismissUntil();
  }

  function dismiss() {
    if (frequency === "day") { setDismissUntil(now() + 24*60*60*1000); return; }
    if (frequency === "week") { setDismissUntil(now() + 7*24*60*60*1000); return; }
    if (frequency === "never") { setDismissUntil(9999999999999); return; }

    setDismissUntil(now() + 24*60*60*1000);
  }

  function open() {
    setPopupHeight();
    overlay.classList.add("is-open");
    lockScroll(true);
    startRotation();
  }

  function close() {
    overlay.classList.remove("is-open");
    lockScroll(false);
    dismiss();
    stopRotation();
  }

  closeBtn?.addEventListener("click", close);
  overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && overlay.classList.contains("is-open")) close(); });

  function onScroll() {
    const doc = document.documentElement;
    const scrollTop = doc.scrollTop || document.body.scrollTop;
    const scrollHeight = doc.scrollHeight - doc.clientHeight;
    if (scrollHeight <= 0) return;
    if ((scrollTop / scrollHeight) >= triggerPct) {
      window.removeEventListener("scroll", onScroll);
      if (shouldShow()) open();
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  // Theme Editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:select", (e) => {
      if (e.target.contains(overlay)) open();
    });
    document.addEventListener("shopify:section:deselect", (e) => {
      if (e.target.contains(overlay)) close();
    });

    // Rotation refresh in design mode when blocks change
    document.addEventListener("shopify:block:select", (e) => {
      if (overlay.contains(e.target)) {
        stopRotation();
        const blockSlide = e.target.closest('.oi-nlp-image__slide');
        if (blockSlide) {
          slides.forEach(s => s.classList.remove('is-active'));
          blockSlide.classList.add('is-active');
          currentSlideIndex = slides.indexOf(blockSlide);
        }
      }
    });
    document.addEventListener("shopify:block:deselect", (e) => {
      if (overlay.contains(e.target) && overlay.classList.contains('is-open')) {
        startRotation();
      }
    });

    // Handle section setting changes (like rotation speed)
    document.addEventListener("shopify:section:load", () => {
       window.location.reload();
    });
  }

  async function subscribeToKlaviyo(email, source) {
    if (!companyId || !listId)
      throw new Error("Missing Klaviyo company_id or list_id.");

    const profileAttributes = { email };
    if (source) profileAttributes.properties = { source };

    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: { data: { type: "list", id: listId } }
        }
      }
    };

    const res = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-07-15"
        },
        body: JSON.stringify(payload)
      }
    );

    if (!res.ok) {
      const err = await res.json().catch(() => null);
      throw new Error(err?.errors?.[0]?.detail || `Klaviyo error ${res.status}`);
    }
    return true;
  }

  form?.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (errEl)
      errEl.hidden = true;

    // Simple captcha
    if (hpEl && (hpEl.value || "").trim())
      return;

    const email = (emailEl?.value || "").trim();
    if (!email) {
      if (errEl) {
        errEl.textContent = "PLEASE ENTER YOUR EMAIL";
        errEl.hidden = false;
      }
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      if (errEl) {
        errEl.textContent = "PLEASE ENTER A VALID EMAIL";
        errEl.hidden = false;
      }
      return;
    }

    // The Cooldown 30s
    const last = Number(localStorage.getItem(SUBMIT_TS_KEY) || 0);
    if (now() - last < 30_000)
      return;

    localStorage.setItem(SUBMIT_TS_KEY, String(now()));

    try {
      await subscribeToKlaviyo(email, source);

      localStorage.setItem(SUBMITTED_KEY, "1");
      form.classList.add("is-hidden");

      if (successEl)
        successEl.classList.add("is-visible");
    } catch (err) {
      if (errEl) {
        errEl.textContent = err?.message || "Something went wrong";
        errEl.hidden = false;
      }
    }
  });
})();